import React from 'react';
import ApplicationFormComponent from '../components/ApplicationForm';

const ApplicationForm = () => {
  return <ApplicationFormComponent />;
};

export default ApplicationForm;
